<template>
  <transition name="fade">
    <div class="wrapper" v-if="visible">
      <div class="outer overlay" @click="close"></div>
      <div class="inner content">
        <div
          class="series-group"
          v-for="(item, index) in series_list"
          :key="index"
        >
          <div :class="{ factory: true, 'blue-bg': is_new_energy == 1 }">
            {{ item.factory_name }}
          </div>
          <div
            class="series-item"
            v-for="(itm, idx) in item.model_alias_list"
            :key="idx"
            @click="toSelectVehicle(item.factory_name, itm)"
          >
            {{ itm }}
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<!-- 厂家车系-弹出层组件 -->
<script>
import api from "@/apis/maintenance-api.js";
export default {
  name: "SeriesPopup",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    initParams: {},
    is_new_energy: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      show: false,
      series_list: [],
    };
  },
  watch: {
    visible(value) {
      if (value && this.initParams.brand_name) {
        this.fetchFactoryAndSeriesNameList();
        const body = document.body;
        body.style.overflow = "hidden";
        body.style.height = "100vh";
      }
    },
  },
  mounted() {},
  destroyed() {
    const body = document.body;
    body.style.overflow = "auto";
    body.style.height = "auto";
  },
  methods: {
    /**
     * 获取厂家车系列表
     */
    async fetchFactoryAndSeriesNameList() {
      this.$loading.show("加载中...");
      try {
        const res = await api.getFactoryAndSeriesNameListApi({
          brand_name: this.initParams.brand_name,
        });
        this.$loading.hide();
        if (res.code === 0) {
          this.series_list = res.data;
        } else {
          this.$toast.show({
            showTime: 3,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        this.$loading.hide();
        console.log("获取厂家车系列表失败！");
        error && console.log(error);
      }
    },
    /**
     * 点击厂家车系列表跳转发动机排量列表
     */
    toSelectVehicle(factory_name, model_alias) {
      this.$router.push({
        name: "engine-displacement",
        query: {
          brand_name: this.initParams.brand_name,
          factory_name,
          model_alias,
          brand_logo_url: this.initParams.logo,
          scheme_id: this.$route.query.id || this.$route.query.scheme_id,
          is_new_energy: this.initParams.is_new_energy,
        },
      });
    },
    /**
     * 点击遮罩层关闭
     */
    close() {
      this.$emit("close");
      this.series_list = [];
      const body = document.body;
      body.style.overflow = "auto";
      body.style.height = "auto";
    },
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 400;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 500;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: flex-end;
}
.content {
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 999;
  width: 480/100rem;
  height: 100%;
  overflow-y: scroll;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 17/100rem 24/100rem 0 26/100rem;
  .series-group {
    // display: flex;
    // flex-direction: column;
    .factory {
      width: 100%;
      margin: 17/100rem 0;
      height: 58/100rem;
      background: #fbce07;
      border-radius: 9/100rem;
      line-height: 0;
      display: flex;
      align-items: center;
      text-indent: 26/100rem;
      color: #333333;
      font-size: 24/100rem;
      font-weight: bold;
    }
    .blue-bg {
      background: #b1e6ec;
    }
    .series-item {
      box-sizing: border-box;
      width: 100%;
      color: #404040;
      padding: 17/100rem 0;
      padding-left: 26/100rem;
      line-height: 36/100rem;
      font-size: 26/100rem;
      &:active {
        background: #f0f0f0;
      }
    }
    &:last-child {
      margin-bottom: 50/100rem;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
